import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=354f10b3&scoped=true"
import script from "./fees.vue?vue&type=script&lang=js"
export * from "./fees.vue?vue&type=script&lang=js"
import style0 from "./fees.vue?vue&type=style&index=0&id=354f10b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f10b3",
  null
  
)

export default component.exports